module.exports = __webpack_public_path__ + "img/perforaciones_4-3_682.42387064.jpg";